import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Box,
  TextField,
  Typography,
  Divider,
} from "@mui/material";
import { buttonStyles } from "utils/buttonStyles";
import { dialogHeaderStyles, dialogContentStyles } from "utils/dialogStyles";

function EditKategoriKutipan({ open, data, onClose, onSave }) {
  const [form, setForm] = useState({
    kategori_kutipan: "",
    kod_kategori: "",
    bahagian_pemantau: "",
  });

  useEffect(() => {
    if (data) {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      setForm({
        kategori_kutipan: data.kategori_kutipan || "",
        kod_kategori: data.kod_kategori || "",
        bahagian_pemantau: data.bahagian_pemantau || user.bahagian || "",
      });
    }
  }, [data, open]);

  // Reset form when dialog closes
  useEffect(() => {
    if (!open) {
      setForm({
        kategori_kutipan: "",
        kod_kategori: "",
        bahagian_pemantau: "",
      });
    }
  }, [open]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    // Validate required fields
    if (!form.kategori_kutipan || form.kategori_kutipan.trim() === "") {
      alert("Sila masukkan kategori kutipan yang diperlukan.");
      return;
    }
    if (!form.bahagian_pemantau || form.bahagian_pemantau.trim() === "") {
      alert("Bahagian Pemantau diperlukan.");
      return;
    }
    // Prepare data for backend - use DB column names directly
    const updateData = {
      kategori_kutipan: form.kategori_kutipan.trim(),
      kod_kategori: form.kod_kategori.trim(),
      bahagian_pemantau: form.bahagian_pemantau.trim(),
    };
    if (onSave) onSave(updateData);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={dialogHeaderStyles.info}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6" sx={{ color: "#fff" }}>Ubahsuai Kategori Kutipan</Typography>
        </Box>
      </DialogTitle>
      <DialogContent dividers sx={dialogContentStyles.light}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <TextField
              label="Kategori Kutipan"
              name="kategori_kutipan"
              value={form.kategori_kutipan}
              onChange={handleChange}
              required
              fullWidth
              margin="dense"
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <TextField
              label="Kod Kategori"
              name="kod_kategori"
              value={form.kod_kategori}
              InputProps={{
                readOnly: true,
              }}
              fullWidth
              margin="dense"
              variant="outlined"
              sx={{
                "& .MuiInputBase-input": {
                  backgroundColor: "#f5f5f5",
                },
              }}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <TextField
              label="Bahagian Pemantau"
              name="bahagian_pemantau"
              value={form.bahagian_pemantau}
              InputProps={{ readOnly: true }}
              required
              fullWidth
              margin="dense"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={dialogContentStyles.light}>
        <Button
          variant="contained"
          onClick={handleSave}
          size="small"
          sx={{
            ...buttonStyles.save,
            m: 0,
            px: 2,
            minWidth: 0
          }}
        >
          SIMPAN
        </Button>
        <Button
          variant="contained"
          onClick={onClose}
          size="small"
          sx={{
            ...buttonStyles.cancel,
            m: 0,
            px: 2,
            minWidth: 0
          }}
        >
          BATAL
        </Button>
      </DialogActions>
    </Dialog>
  );
}

EditKategoriKutipan.propTypes = {
  open: PropTypes.bool.isRequired,
  data: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default EditKategoriKutipan;
